import { render, staticRenderFns } from "./knowledgeBaseSearch.vue?vue&type=template&id=a4554b7a&scoped=true&"
import script from "./knowledgeBaseSearch.vue?vue&type=script&lang=js&"
export * from "./knowledgeBaseSearch.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeBaseSearch.vue?vue&type=style&index=0&id=a4554b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4554b7a",
  null
  
)

export default component.exports